export default class Calculator {
    static init() {
        return new Calculator();
    }

    constructor() {
        window.calculator = this.calculatorLogic;
    }

    calculatorLogic() {
        return {
            a: null,
            b: null,
            ws: null,
            area: 0,
            weight: 0,
            el: null,
            form: null,

            initCalcForm(el) {
                if (!el)
                    return;

                this.el = el;
                this.form = el.querySelector('.calc-form');
            },

            // Helper function to parse comma-separated numbers
            parseNumber(value) {
                if (!value) return 0;
                // Convert string to number, replacing commas with dots
                return parseFloat(value.toString().replace(',', '.'));
            },

            calculate() {
                // Parse the values, converting commas to dots for calculations
                const a = this.parseNumber(this.a);
                const b = this.parseNumber(this.b);
                const ws = this.parseNumber(this.ws);

                if (this.form.classList.contains('square-tubing')) {
                    this.area = Number((a * b - (a - 2 * ws) * (b - 2 * ws)).toFixed(3));
                } else if (this.form.classList.contains('square-rod')) {
                    this.area = Number((a * b).toFixed(3));
                } else if (this.form.classList.contains('round-tubing')) {
                    this.area = Number((Math.PI/4 * ((a * a) - (a - 2 * ws) * (a - 2 * ws))).toFixed(3));
                } else if (this.form.classList.contains('round-rod')) {
                    this.area = Number(((a/2)*(a/2) * Math.PI).toFixed(3));
                } else if (this.form.classList.contains('t-profile')) {
                    this.area = Number((a * ws + b * ws).toFixed(3));
                } else if (this.form.classList.contains('u-profile')) {
                    this.area = Number((2* (a * ws) + (b-2 * ws) * ws).toFixed(3));
                } else if (this.form.classList.contains('angled-profile')) {
                    this.area = Number((a * ws + b * ws - 2*ws).toFixed(3));
                }

                this.weight = Number((this.area * 2.71 / 1000).toFixed(2));
            }
        }
    }
}